import { useState } from "react";

import { BenefitRow } from "entities/benefits";
import { SelectLanguage } from "features/select-language";
import { SelectTimeZone } from "features/select-time-zone/select-time-zone";
import { Item } from "pages/settings/ui/item";
import { Layout } from "pages/ui/page/layout";
import Gift from "shared/assets/svgs/gift.svg?react";
import { Button } from "shared/ui/button";
import { Input } from "shared/ui/input";
import { Notification } from "shared/ui/notification";
import { Panel } from "shared/ui/panel";
import { ProgressLine } from "shared/ui/progress-line";
import { Select } from "shared/ui/select";
import { Tab, Tabs } from "shared/ui/tabs";

export const Dev = () => {
  const [_isOpen, setIsOpen] = useState(false);
  const [_isSheetOpen, setIsSheetOpen] = useState(false);
  const [tab, setTab] = useState<"Hello" | "World">("Hello");

  return (
    <Layout className="text-white">
      <div className="flex gap-x-2.5">
        <Button disabled>Start Your Free 14-Day Trial</Button>
        <Button size="34" className="rounded-full">
          Hello world
        </Button>
        <Button theme="white">Hello world</Button>
        <Button theme="white" disabled>
          Hello world
        </Button>
        <Button theme="text">Hello world</Button>
        <Button theme="transparent">Hello world</Button>
      </div>

      <div>
        <Notification type="default">Hello world</Notification>
        <Notification type="info">Hello world</Notification>
        <Notification type="danger">Hello world</Notification>
      </div>

      <div>
        <BenefitRow
          title="14-Day Free Trial"
          description="Full access to all features with no commitment required."
          icon={<Gift className="text-crystal-blue w-full" />}
        />
      </div>

      <Item
        title="Connected Accounts"
        description="You have connected 1 account"
        icon={<div>icon</div>}
      >
        <span>Hello world</span>
      </Item>

      <div className="mt-4">
        <Input placeholder="Add Instructions for AI Assistant..." />

        <Select />
      </div>

      <div className="mt-4">
        <Button
          onClick={() => {
            setIsOpen(true);
          }}
        >
          OPEN Remove Dialog
        </Button>
        {/* <RemoveAccountDialog isOpen={isOpen} onOpenChange={setIsOpen} /> */}
      </div>

      <div>
        <Button
          onClick={() => {
            setIsSheetOpen(true);
          }}
        >
          Open Sheet
        </Button>

        {/* <AddAccountInstructionsSheet
          initialValue="adsasd"
          isOpen={isSheetOpen}
          onClose={() => setIsSheetOpen(false)}
        /> */}
      </div>
      {/* 
      <div className="flex max-w-3xs">
        <SetPermissionRow
          icon={<img className="size-full" src={calendarIcon} />}
          title="Calendar"
        />
        <SetPermissionRow
          icon={<img className="size-full" src={calendarIcon} />}
          title="Calendar"
        />
      </div> */}

      <div>
        <Tabs variant="buttons">
          <Tab isActive={tab === "Hello"} onClick={() => setTab("Hello")}>
            Hello
          </Tab>
          <Tab isActive={tab === "World"} onClick={() => setTab("World")}>
            World
          </Tab>
        </Tabs>
      </div>

      <div>
        <ProgressLine count={3} activeStepIndex={1} />
      </div>

      <SelectLanguage
        code="en"
        onSelect={(code) => {
          console.log(code);
        }}
      />

      <SelectTimeZone
        tzCode=""
        onSelect={(zone) => {
          console.log(zone);
        }}
      />

      <Panel>Hello world</Panel>
    </Layout>
  );
};
